import Transmissions from '@/features/transmissions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/transmissions/')({
  head: () => ({
    meta: [{
      title: 'Transmissões | Wazai',
    }]
  }),
  component: Transmissions,
})
